import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import classNames from 'classnames';
import ManagedAccountAllocationCleanupDialogContent
  from 'Views/Page/Content/Modal/Layouts/ManagedAccountAllocationCleanupDialog/Content';
import PropTypes from 'prop-types';
import React from 'react';
import { Box } from '@material-ui/core';
import {
  ManagedAccountAllocationHistoryContextProvider,
} from 'Views/Page/Content/Modal/Layouts/ManagedAccountAllocationCleanupDialog/Context';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import fr from 'facet-rest';

const styles = () => ({
  root: {
    minWidth: 800,
    display: 'flex',
    flexDirection: 'column',
  },
});

const ManagedAccountAllocationCleanupDialog = ({
  className,
  classes,
}) => {
  const {
    resource,
  } = useMetaLayoutContext();

  const link = resource.relationship(fr.relationships.modelChangeEvents.name).link('related').url();

  return (
    <Box className={classNames(classes.root, className)}>
      <ManagedAccountAllocationHistoryContextProvider link={link}>
        <ManagedAccountAllocationCleanupDialogContent />
      </ManagedAccountAllocationHistoryContextProvider>
    </Box>
  );
};

ManagedAccountAllocationCleanupDialog.defaultProps = {
  className: '',
};

ManagedAccountAllocationCleanupDialog.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ManagedAccountAllocationCleanupDialog);
